module.exports = __webpack_public_path__ + "static/media/Category-Sports.323469c1.jpg";